import { ValidationResult } from './types'
import i18n from 'i18next'

const validateUploadedFiles = (
	idDocumentNationalityExemptions: string[] | null,
	nationalities?: string[],
	files?: File[],
): ValidationResult => {
	if (
		idDocumentNationalityExemptions != null &&
		!idDocumentNationalityExemptions.some((nationalityCode) =>
			nationalities?.includes(nationalityCode),
		) &&
		(!files || files.length === 0)
	) {
		return {
			success: false,
			output: i18n.t('validation-fieldRequired'),
		}
	}
	return {
		success: true,
		output: '',
	}
}

export default validateUploadedFiles
